module.exports = __webpack_public_path__ + "static/media/Trial1-if-wrong.7299d136.mp3";